/* loaded by smart-asset */
export default require("./default-logo~bhufbMTK.png")